<template>
  <div class="passPlatform">
    <AppBar />
    <div class="page-content">
      <div class="page-canvas">
        <div class="por-container">
          <div class="page-info">
            <div class="page-info-title">
              前端PASS智能平台
            </div>
            <div class="page-info-describe">
              <div class="describe">建立一种有华跃特色的低代码设置平台，</div>
              <div class="describe">满足企业在发展过程中对于软件工具的简单二次开发要求</div>
            </div>
          </div>
        </div>
      </div>
      <div class="platform-advantage">
        <div class="title">
          平台优势·低代码
        </div>
        <div class="advantage-list">
          <div
            v-for="(item, index) in advantageList"
            :key="index"
            class="advantage-list-item"
          >
            <div class="list-item-img-box">
              <img :src="item.img" alt="" class="list-item-img" />
            </div>
            <div class="list-item-text-box">
              <div class="list-item-title">
                {{ item.title }}
              </div>
              <div class="list-item-describe">
                {{ item.describe }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="characteristic-wrap">
        <div class="title">
          具有华跃特色的PASS智能平台
        </div>
        <div class="characteristic-tag-list">
          <div
            v-for="(item, index) in characteristicList"
            :key="index"
            :class="['tag-list-item', characteristicIndex == index ? 'tag-list-item-change' : '']"
            @click="changeStep(index)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="characteristic-content-box">
          <transition name="characteristic-fade" mode="out-in">
            <div
              v-if="characteristicList.length > 0"
              :key="characteristicIndex"
              class="characteristic-content"
            >
              <div class="content-txt-wrap">
              <div class="content-tit">
                  {{ characteristicList[characteristicIndex].title }}
              </div>
              <div class="content-txt">
                  {{ characteristicList[characteristicIndex].describe }}
              </div>
              </div>
              <div class="content-img-wrap">
              <img :src="characteristicList[characteristicIndex].img" alt="" />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild } from '@/api/column';
import { getContentList } from '@/api/content';
export default {
  name: 'PlatformView',
  data() {
    return {
      advantageList: [
        // {
        //   title: '兼容性高',
        //   describe: '随着企业发展业务流程变化是不可避免的，但是低代码开发平台使更改应用程序并使它们适应新要求变得非常容易。无论是简单的任务还是复杂的工作流程，用户都无需编写代码即可实现。',
        //   img: require('@/assets/pass/advantage1.png'),
        // },
      ],
      characteristicIndex: 0,
      characteristicList: [
        // {
        //   title: '自定义可视化配置',
        //   describe: '模块管理，可以完全根据客户要求进行可视化配置',
        //   img: require('@/assets/pass/characteristic1.png'),
        // },
      ],
    }
  },
  mounted () {
    this.getPageColumn()
  },
  methods: {
    getPageColumn() {
      const params = { parentId: '1610879565574660096', };
      getColumnChild(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if(result[i].name === '平台优势') {
            getContentList({ columnId: result[i].id, pageNum: 1, pageSize: 99, }).then((rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var advantage = {
                  title: rrsult.data[j].title,
                  describe: rrsult.data[j].description,
                  img: rrsult.data[j].icon,
                }
                this.advantageList.push(advantage);
              }
            })
          } else if(result[i].name === '平台特色') {
            getContentList({ columnId: result[i].id, pageNum: 1, pageSize: 99, }).then((rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var characteristic = {
                  title: rrsult.data[j].title,
                  describe: rrsult.data[j].description,
                  img: rrsult.data[j].icon,
                }
                this.characteristicList.push(characteristic)
              }
            })
          }
        }
      })
    },

    changeStep(i) {
      this.characteristicIndex = i
    },

    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  }
}
</script>

<style lang="less" scoped>
.passPlatform{
  background-color: #fff;
  position: relative;
  .page-content{
    width: 100%;
    .page-canvas{
      width: 100%;
      height: 360px;
      min-width: var(--minwidth);
      background: url('@/assets/pass/canvas.png') no-repeat;
      background-size: cover;
      background-position: center;
      .por-container{
        width: 70%;
        min-width: var(--minwidth);
        height: 100%;
        margin: 0 auto;
        position: relative;
        .page-info{
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          .page-info-title{
            font-family: OPPOSans-R;
            color: #fff;
            font-size: 36px;
            font-weight: 300;
            line-height: 1;
            margin-bottom: 20px;
          }
          .page-info-describe{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            .describe{
              font-size: 16px;
              font-weight: 200;
              color: #fff;
              line-height: 25px;
            }
          }
        }
      }
    }
    .platform-advantage{
      width: 1200px;
      margin: 0 auto;
      margin-top: 80px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .title{
        font-family: OPPOSans-M;
        font-size: 32px;
        color: #21252b;
      }
      .advantage-list{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 70px;
        margin-bottom: 90px;
        .advantage-list-item{
          flex: 1;
          height: 460px;
          margin-right: 21px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          background-color: #f8fafc;
          border-radius: 8px;
          &:last-child{
            margin-right: 0px;
          }
          .list-item-img-box{
            width: 100%;
            padding-top: 30px;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            .list-item-img{
              width: auto;
              height: 135px;
              display: block;
            }
          }
          .list-item-text-box{
            width: 300px;
            margin-top: 30px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            .list-item-title{
              font-family: OPPOSans-M;
              font-size: 20px;
              color: #21252b;
              margin-bottom: 25px;
            }
            .list-item-describe{
              font-family: OPPOSans-R;
              font-size: 14px;
              color: #5c6066;
              line-height: 23px;
            }
          }
        }
      }
    }
    .characteristic-wrap{
      background-color: #f2f5fa;
      padding-top: 65px;
      padding-bottom: 60px;
      .title{
        font-family: OPPOSans-M;
        font-size: 32px;
        color: #21252b;
        text-align: center;
        margin-bottom: 45px;
      }
      .characteristic-tag-list{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .tag-list-item{
          flex: 1;
          height: 42px;
          margin-right: 21px;
          background-color: #fff;
          border-radius: 21px;
          line-height: 42px;
          text-align: center;
          cursor: pointer;
          color: #21252b;
          font-size: 16px;
          font-family: OPPOSans-R;
          transition: all 0.3s ease-in-out;
          &:last-child{
            margin-right: 0;
          }
        }
        .tag-list-item-change{
          background-color: #00b0dc;
          box-shadow: 0px 1px 8px 0px rgba(0, 176, 220, 0.3);
          color: #fff;
        }
      }
      .characteristic-content-box{
        width: 1200px;
        margin: 0 auto;
        padding: 0 50px;
        box-sizing: border-box;
        .characteristic-content{
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          margin-top: 40px;
          .content-txt-wrap{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            .content-tit{
              font-family: OPPOSans-R;
              font-size: 16px;
              color: #21252b;
              margin-bottom: 15px;
            }
            .content-txt{
              font-family: OPPOSans-R;
              font-size: 14px;
              color: #5c6066;
              margin-bottom: 20px;
            }
            .content-img-wrap{
              width: 100%;
              img{
                width: 100%;
                height: auto;
                display: block;
              }
            }
          }
        }
        .characteristic-fade-enter-active {
          animation: bounce-in 0.5s;
        }
        .characteristic-fade-leave-active {
          animation: bounce-in 0s reverse;
        }
        @keyframes bounce-in {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
